var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPitchDeck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 0.375H13.8333C14.0433 0.375 14.2447 0.458407 14.3931 0.606874C14.5416 0.75534 14.625 0.956703 14.625 1.16667V6.70833H0.375V1.16667C0.375 0.956703 0.458407 0.75534 0.606874 0.606874C0.75534 0.458407 0.956704 0.375 1.16667 0.375ZM0.375 8.29166H14.625V13.8333C14.625 14.0433 14.5416 14.2447 14.3931 14.3931C14.2447 14.5416 14.0433 14.625 13.8333 14.625H1.16667C0.956704 14.625 0.75534 14.5416 0.606874 14.3931C0.458407 14.2447 0.375 14.0433 0.375 13.8333V8.29166ZM3.54167 10.6667V12.25H5.91667V10.6667H3.54167ZM3.54167 2.75V4.33333H5.91667V2.75H3.54167Z",
    fill: "#85B440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchDeck);
export default __webpack_public_path__ + "static/media/pitch-deck.2d8c607cf92118d2dba0f4f3aca9f1c8.svg";
export { ForwardRef as ReactComponent };